module.exports = __webpack_public_path__ + "static/tanker-40df62c21640f80493e6c3df0126f558.png";